export const CLOSE_ON_ESCAPE = 'fullscreen.closeOnEscape';
export const CLOSE_ON_CLICK = 'fullscreen.closeOnClick';